import React, { useEffect, useState } from "react";
import axios from "axios";

const AddUser = () => {
  const [registered, setRegistered] = useState(false);
  const [register, setRegister] = useState({
    firstname: "",
    lastname: "",
    username: "",
    password: "",
    email: "",
    mobile: "",
    language: 1,
    error: "",
    city: 0,
    state: 34,
  });
  const [formerror, setFormError] = useState("");
  const [languages, setlanguages] = useState([]);
  const [states, setstates] = useState([]);
  const [cities, setcities] = useState([]);

  const resetMessage = (e) => {
    setMessage(() => {
      return {
        type: null,
        message: "",
      };
    });
  };

  const [message, setMessage] = useState({
    type: null,
    text: "",
  });

  const getMessage = () => {
    if (message.type) {
      return (
        <div className={`alert alert-${message.type}`} role="alert">
          <button type="button" className="close" onClick={resetMessage}>
            <span aria-hidden="true">&times;</span>
          </button>
          <strong className="d-block d-sm-inline-block-force">
            {message.type === "success" ? "Well done!" : "Oops!"}
          </strong>{" "}
          {message.message}
        </div>
      );
    }
  };

  const changeData = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setRegister((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    if (name === "email") {
      setRegister((prev) => {
        return {
          ...prev,
          username: value.split("@")[0],
        };
      });
    }
    if (name === "state") {
      setRegister((prev) => {
        return {
          ...prev,
          city: 0,
        };
      });

      getCity(value);
    }
  };

  const removeError = (e) => {
    setFormError("");
  };

  const validate = () => {
    if (!register.firstname) {
      setFormError("Please type first name.");
      return false;
    }
    if (
      !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        register.email
      )
    ) {
      setFormError("Please type a valid email address");
      return false;
    }
    if (
      !/((\+*)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(
        register.mobile
      )
    ) {
      setFormError("Please type a valid mobile number");
      return false;
    }
    if (!/^[a-zA-Z0-9\\.|-|_]+$/.test(register.username)) {
      setFormError("Please type a valid login id");
      return false;
    }
    if (!register.password) {
      setFormError("Please type password.");
      return false;
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        register.password
      )
    ) {
      setFormError(
        "Password should have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
      );
      return false;
    }

    if (register.state === 0) {
      setFormError("Please select state.");
      return false;
    }
    if (register.city === 0) {
      setFormError("Please select city.");
      return false;
    }

    return true;
  };
  const getSignUp = async (e) => {
    console.log(register);
    let user = JSON.parse(localStorage.getItem("user"));
    //return;
    e.preventDefault();
    if (validate()) {
      try {
        await axios
          .post(localStorage.getItem("basurl") + "/users", register, {
            headers: { "mojo-access-tokens": user.token },
          })
          .then((response) => {
            setRegistered(true);
            setMessage(() => {
              return {
                type: "success",
                message: response.data.message,
              };
            });
            setRegister({
              firstname: "",
              lastname: "",
              username: "",
              password: "",
              email: "",
              mobile: "",
              language: 1,
              error: "",
              city: 0,
              state: 34,
            });
          })
          .catch((err) => {
            setFormError(err.response.data.message);
          });
      } catch (err) {
        setFormError(err.message);
      }
    }
  };

  const getLanguage = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/languages")
        .then((response) => {
          setlanguages(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getState = async () => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/states")
        .then((response) => {
          setstates(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  const getCity = async (val) => {
    try {
      await axios
        .get(localStorage.getItem("basurl") + "/cities/" + val)
        .then((response) => {
          setcities(response.data);
        })
        .catch((err) => {
          setFormError(err.response.data.message);
        });
    } catch (err) {
      setFormError(err.message);
    }
  };

  useEffect(() => {
    getLanguage();
    getState();
    getCity(register.state);
  }, []);

  return (
    <>
      <div className="card shadow-base bd-0 pd-20">
        {getMessage()}
        <span className="text-danger">{formerror}</span>
        <form method="post" onSubmit={getSignUp}>
          <div className="row">
            {/* firstname */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-man tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-firstname"
                  type="text"
                  name="firstname"
                  value={register.firstname}
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter first name"
                  className="form-control"
                />
              </div>
            </div>
            {/* lastname */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-man tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-lastname"
                  type="text"
                  name="lastname"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter last name"
                  className="form-control"
                  value={register.lastname}
                />
              </div>
            </div>
            {/* email */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-email tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-email"
                  type="email"
                  name="email"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter email address"
                  className="form-control"
                  value={register.email}
                />
              </div>
            </div>
            {/* mobile */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-iphone tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-mobile"
                  type="phone"
                  name="mobile"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter mobile number"
                  className="form-control"
                  maxLength={10}
                  value={register.mobile}
                />
              </div>
            </div>
            {/* username */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-person tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-username"
                  type="text"
                  name="username"
                  readOnly={true}
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter login id"
                  className="form-control"
                  value={register.username}
                />
              </div>
            </div>
            {/* password */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="icon ion-key tx-16 lh-0 op-6"></i>
                </span>
                <input
                  id="signup-password"
                  type="password"
                  name="password"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please enter password"
                  className="form-control"
                  value={register.password}
                />
              </div>
            </div>
            {/* state */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="fa fa-location-arrow tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-state"
                  name="state"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose state"
                  className="form-control"
                  value={register.state}
                >
                  {states.map((state) => (
                    <option key={`state` + state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* city */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="fa fa-location-arrow tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-city"
                  name="city"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose city"
                  className="form-control"
                  value={register.city}
                >
                  <option key={`city0`} value={0}>
                    --select--
                  </option>
                  {cities.map((city) => (
                    <option key={`city` + city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* language */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <span className="input-group-addon">
                  <i className="fa fa-language tx-16 lh-0 op-6"></i>
                </span>
                <select
                  id="signup-language"
                  name="language"
                  onFocus={removeError}
                  onChange={changeData}
                  placeholder="Please choose language"
                  className="form-control"
                  value={register.language}
                >
                  {languages.map((lang) => (
                    <option key={`lang` + lang.id} value={lang.id}>
                      {lang.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* submit */}
            <div className="col-sm-6">
              <div className="form-group input-group">
                <button type="submit" className="btn btn-success pull-right">
                  Add User
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default AddUser;
